<template>
  <div class="main">
    <BasicDialog :rounded="'rounded-24'">
      <v-row no-gutters class="flex-column px-sm-16">
        <v-row no-gutters class="justify-center">



          <v-col cols="12" style="position: relative" class="d-flex justify-center align-center">
            <img :src="AppConfigs.staticImages.PAYPALWITHDRAWLSUCCESSFULL" class="payout-withdrawl-dialog__image" />
          </v-col>




        </v-row>
        <v-row no-gutters class="d-flex justify-center mt-4 flex-column align-center">




          <span class="text-h5 font-weight-bold text-center">Request Submitted!</span>
          <span class="text-body-2 mt-1 text-center">Your withdrawal money has been sent to your Paypal</span>





        </v-row>
    
        <v-row no-gutters class="justify-center mt-5">




          <v-btn rounded="pill" @click="redirectToPaypal"
            class="  button--primary text-body-1 font-weight-medium px-16 py-6 d-flex text-none">
            <span>Go to Paypal</span>
          </v-btn>




        </v-row>
      </v-row>
    </BasicDialog>
  </div>
</template>



<script lang="ts">

import { useRouter } from 'vue-router';
import { AppConfigs } from "@/app.configs";
import { PayoutStore } from "@/store/PayoutStore";
import { computed, watch, ref, provide } from "vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";

export default {
  name: "AmazonWithdrawalSuccessfull",
  components: {
    BasicDialog,
  },
  setup() {
    const router = useRouter();
    const openDialog = ref(false);
    provide("openDialog", openDialog);

    const payoutStore = PayoutStore();
    const payoutData = computed(() => payoutStore.SuccessResponsePayoutData);

    watch(payoutData, () => {
      openDialog.value = true;
    });

    const redirectToPaypal = () => {
      openDialog.value = false;
      window.open('https://www.paypal.com', '_blank');
    };

    return { 
      AppConfigs,
      payoutData, 
      openDialog, 
      redirectToPaypal
    };
  },
};
</script>